import { render, staticRenderFns } from "./KBSelectAdvisor.vue?vue&type=template&id=a70a1710&scoped=true&"
import script from "./KBSelectAdvisor.vue?vue&type=script&lang=ts&"
export * from "./KBSelectAdvisor.vue?vue&type=script&lang=ts&"
import style0 from "./KBSelectAdvisor.vue?vue&type=style&index=0&id=a70a1710&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70a1710",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
